import { render, staticRenderFns } from "./goods-flowing.vue?vue&type=template&id=ac6cdd92&scoped=true"
import script from "./goods-flowing.vue?vue&type=script&lang=js"
export * from "./goods-flowing.vue?vue&type=script&lang=js"
import style0 from "./goods-flowing.vue?vue&type=style&index=0&id=ac6cdd92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6cdd92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac6cdd92')) {
      api.createRecord('ac6cdd92', component.options)
    } else {
      api.reload('ac6cdd92', component.options)
    }
    module.hot.accept("./goods-flowing.vue?vue&type=template&id=ac6cdd92&scoped=true", function () {
      api.rerender('ac6cdd92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/goods-flowing.vue"
export default component.exports